import {Component, Input, OnDestroy, ViewChild} from "@angular/core";
import {AriadnextUser, AriadVerificationStatus} from "../../../api/entity";
import {AriadnextService} from "../../../api/service";
import {Observable, Subscription} from "rxjs";
import {FileUtils} from "../../../../../../../../common/utils";
import {CreateApplicantDialogComponent} from "./create-applicant.dialog.component";
import {NotificationManager} from "../../../../../../../../common/providers/notification";

@Component({
    selector: 'tfl-bo-ariadnext-client-user',
    template: require('./client-user.ariadnext.verification.component.html')
})
export class ClientUserAriadnextVerificationComponent implements OnDestroy {

    @Input("loading") loading: boolean;
    @Input("profileId") profileId: number;
    @Input("user") ariadnextUser: AriadnextUser;

    private httpDetailsSubscription: Subscription = new Subscription();

    @ViewChild(CreateApplicantDialogComponent) createApplicantDialog: CreateApplicantDialogComponent;

    constructor(private _ariadnextService: AriadnextService, private _notificationManager: NotificationManager) {
    }

    ngOnDestroy(): void {
        this.httpDetailsSubscription.unsubscribe();
    }

    openCreationDialog() {
        this.createApplicantDialog.show();
    }

    createApplicant(byPhone: boolean) {
        let userId = this.ariadnextUser.userId;
        this.loading = true;
        this._ariadnextService
            .createApplicant(this.profileId, userId, byPhone)
            .subscribe(_ => {
                // For each 3 seconds
                this.httpDetailsSubscription = Observable
                    .interval(1000 * 3)
                    // While results don't have applicant ids
                    .takeWhile(() => this.loading)
                    .subscribe(_ => {
                        // Fetch profile and check attached users to be at least created in ariadnext regardless of statuses
                        this._ariadnextService
                            .getResultByUser(this.profileId, userId)
                            .subscribe(user => {
                                if (user.lastAriadnextStatus !== AriadVerificationStatus.OUT_OF_VERIFICATION) {
                                    this.ariadnextUser = user;
                                    this.loading = false;
                                }
                            });
                    });
            }, error =>  {
                this._notificationManager.error(error.errorMessage);
                this._ariadnextService
                    .getResultByUser(this.profileId, userId)
                    .subscribe(user => {
                        this.ariadnextUser = user;
                        this.loading = false;
                    });
            });
    }

    verify() {
        let userId = this.ariadnextUser.userId;
        this._ariadnextService
            .verify(this.profileId, userId)
            .subscribe(_ => {
                this._ariadnextService
                    .getResultByUser(this.profileId, userId)
                    .subscribe(user => this.ariadnextUser = user);
            });
    }

    decline() {
        let userId = this.ariadnextUser.userId;
        this._ariadnextService
            .decline(this.profileId, userId)
            .subscribe(_ => {
                this._ariadnextService
                    .getResultByUser(this.profileId, userId)
                    .subscribe(user => this.ariadnextUser = user);
            });
    }

    documents() {
        this._ariadnextService
            .downloadDocument(this.ariadnextUser.documentReportCode)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            })
    }

    selfie() {
        this._ariadnextService
            .downloadDocument(this.ariadnextUser.selfieReportCode)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            })
    }

    getBoxColorClass() {
        switch (this.ariadnextUser.lastAriadnextStatus) {
            case AriadVerificationStatus.OK:
                return 'state-approved';
            case AriadVerificationStatus.WARN:
            case AriadVerificationStatus.ERROR:
                return 'state-error';
            default:
                return 'state-progress';
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/result/client-user.ariadnext.verification.component.ts